const LanguageSlugRoute = '/:lang';
const HomeRoute = '/';
const SearchRoute = '/search';
const DetailRoute = '/detail';
const AgreementRoute = '/agreements';
const ExporterRoute = '/first-time-exporter';
const ProductSearchRoute = '/product-search';
const HelpDeskRoute = '/help-desk';
const AboutRoute = '/about-us';
const RulesOfOriginRoute = '/rules-of-origin';
const PreferentialTreatmentRoute = '/preferential-treatment';
const LoginRoute = '/login';
const RegisterRoute = '/register';
const PrivacyPolicyRoute = '/privacy-policy';
const TermsOfUseRoute = '/terms-of-use';
const DisclaimerRoute = '/disclaimer';
const KeynotesRoute = '/keynotes';
const NewsDetailRoute = '/news-detail';
const TradeDetailRoute = '/trade-detail';
const RequestResetPasswordRoute = '/request-reset-password';
const ResetPasswordRoute = '/reset-password';
const UserGuideRoute = `${HelpDeskRoute}/user-guide`;
const BasicInformationRoute = `${HelpDeskRoute}/basic-information`;
const HelpDeskRulesOfOriginRoute = `${HelpDeskRoute}/rules-of-origin`;
const CambodiaCustomGuidesRoute = `${HelpDeskRoute}/cambodia-custom-guides`;
const SiteGlossaryRoute = `${HelpDeskRoute}/site-glossary`;
const FaqRoute = `${HelpDeskRoute}/faq`;

export {
  LanguageSlugRoute,
  HomeRoute,
  SearchRoute,
  DetailRoute,
  AgreementRoute,
  ExporterRoute,
  ProductSearchRoute,
  HelpDeskRoute,
  AboutRoute,
  RulesOfOriginRoute,
  PreferentialTreatmentRoute,
  LoginRoute,
  RegisterRoute,
  PrivacyPolicyRoute,
  KeynotesRoute,
  TermsOfUseRoute,
  DisclaimerRoute,
  NewsDetailRoute,
  TradeDetailRoute,
  UserGuideRoute,
  BasicInformationRoute,
  HelpDeskRulesOfOriginRoute,
  CambodiaCustomGuidesRoute,
  SiteGlossaryRoute,
  FaqRoute,
  ResetPasswordRoute,
  RequestResetPasswordRoute,
};
